import { QueryCombinerType } from 'module/api/filter/types';
import { ColumnOrder } from 'module/ui/components/molecules/column-order';
import { FieldFilter } from '../filter';
import { FilterGroupType } from './group';
import { AiFieldFilter } from '../filter/index';

interface AiFields {
  id?: string;
  value: string;
  isAiGenerated: boolean;
  fieldName: string;
}

export interface GroupCriteria {
  id: FilterGroupType;
  hidden?: boolean;
  criteria: FieldFilter | AiFieldFilter;
  key?: string;
}

export interface GroupedFilter {
  type: QueryCombinerType;
  defaultGroup: FilterGroupType;
  groupCriteria: GroupCriteria[];
  aiFields?: AiFields[];
}

export const defaultGroupedFilter = (
  defaultGroup = FilterGroupType.Task,
): GroupedFilter => ({
  type: QueryCombinerType.All,
  defaultGroup,
  groupCriteria: [],
});

export interface GroupedFilterViewDefinition {
  filter: GroupedFilter;
  groupBy?: { rowGroup: string | null; columnGroup: string | null };
  columnOrder?: ColumnOrder[];
}
